import "./App.css";
import Form from "./component/Form";

function App() {
  return (
    <div>
      <Form />
    </div>
  );
}

export default App;
